import { CSS_HELPERS, MEDIA_SCREENS, THEME_COLORS } from '@theme/constants';
import { Card, Col, Divider, Popover, Typography } from 'antd'
import React, { useState } from 'react'
import styled from 'styled-components';


const HistoriaCard = ({
  refference,
  videoUrl,
  titulo,
  descripcion,
  handlePlay,
  handlePause
}) => {

  const [playing, setPlaying] = useState(true);

  const togglePlay = () => {
    if (playing) {
      handlePause();
    } else {
      handlePlay();
    }
    setPlaying(false);
  }
  return (
    <View onClick={togglePlay}>

      <VideoCard>

        <video
          // autoPlay={true}
          muted={true}
          ref={refference}
          src={videoUrl}
          controls={false}
          loop={true}
        />

        <VideoFooter>
          <div className="footerTitle">
            <Typography.Title level={4}>{titulo}</Typography.Title>
          </div>

        </VideoFooter>
      </VideoCard>

      <Divider />


      <p style={{ textAlign: 'justify' }} className="sm strong500">{descripcion}</p>
    </View>
  )
}

export default HistoriaCard;

const View = styled.div`
  width: 100%;
  @media screen and  (min-width: ${0}px) and (max-width: ${MEDIA_SCREENS.XS}px) { 
        width:80%;
    }
    @media screen and  (min-width: ${MEDIA_SCREENS.XS}px) and (max-width: ${MEDIA_SCREENS.SM}px) { 
        width:33%;
    }
    @media screen and  (min-width: ${MEDIA_SCREENS.SM}px) and (max-width: ${MEDIA_SCREENS.MD}px) { 
        width:33%;
    }
    @media screen and  (min-width: ${MEDIA_SCREENS.MD}px) and (max-width: ${MEDIA_SCREENS.LG}px) { 
        width:20%;
    };
    @media screen and  (min-width: ${MEDIA_SCREENS.LG}px)  { 
        width:20%;
    }
  
    padding:.6em;
    p {
      line-height: 1.5em;
    }
`

const VideoCard = styled.div`
  ${CSS_HELPERS.BOX_SHADOW};
  border-radius: 3em;
  overflow: hidden;
  display:flex;
  justify-content: center;
  position:relative;
  width:100%;
  
  @media screen and  (min-width: ${MEDIA_SCREENS.LG}px)  { 
    height: 33em;
  };
  @media screen and  (min-width: ${MEDIA_SCREENS.MD}px) and (max-width: ${MEDIA_SCREENS.LG}px) { 
    height: 33em;
  };
  @media screen and  (min-width: ${MEDIA_SCREENS.SM}px) and (max-width: ${MEDIA_SCREENS.MD}px) { 
    height: 33em;
  }
  @media screen and  (min-width: ${MEDIA_SCREENS.XS}px) and (max-width: ${MEDIA_SCREENS.SM}px) { 
    height: 33em;
  }
  @media screen and  (min-width: ${0}px) and (max-width: ${MEDIA_SCREENS.XS}px) { 
    height: 33em;
  }
  video{
    width: 100%;
    height:100% ;
    object-fit:cover ;
  }
`

const VideoFooter = styled.div`
  border-top:.7em solid ${THEME_COLORS.light.secondary.main};
  background-color: ${THEME_COLORS.light.primary.main};

  position:absolute;
  bottom:0;
  width:100%; 
  height: 9em;
  display:flex;
  flex-direction:column;
  justify-content: center;
  align-items:center ;
  text-align:center;

  .footerTitle{
    max-width:12em ;
  }

  .ant-typography{
    color:white;
  }
`